export default __webpack_public_path__ + "static/media/Danielle_Avery_AHV_In_Moms_We_Trust.c2a131fb.jpg";